import classNames from 'classnames'
import { IPhoneEditor } from 'legacy/lut/components/widgets/public/phoneEditor/models'
import { PhoneEditor } from 'legacy/lut/components/widgets/public/phoneEditor/PhoneEditor'
import { JSX } from 'react'

import { createComponentFn } from 'onboarding/components/helpers/createComponentFn'
import themesStyles from 'onboarding/components/themes.module.scss'

type TComponentFn = (props: IPhoneEditor) => JSX.Element | null

const applyDisabled = (component: TComponentFn) => {
  return (props: IPhoneEditor) => {
    const { isDisabled, className } = props
    const disabledTheme = isDisabled ? themesStyles.disabledInput : undefined

    return component({
      ...props,
      className: classNames(className, disabledTheme),
    })
  }
}

export const OnboardingPhoneEditor = (props: IPhoneEditor) =>
  applyDisabled(createComponentFn<IPhoneEditor & JSX.IntrinsicAttributes>(PhoneEditor))(props)
